<script setup>
import { reactive, getCurrentInstance } from 'vue';

// Props & Emits
const props = defineProps({
    options: Object,
});

const emit = defineEmits(['hide-modal']);

// Store Access
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
// We use reactive here to maintain the object structure from options.row
const row = reactive({ ...props.options.row });

// Methods
const saveNote = () => {
    store.dispatch('itemData/update', {
        tableName: 'odp_course_bookings',
        id: row.id,
        data: {
            paymentNote: row.paymentNote
        }
    });
};
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Notes</h4>

                <button
                    type="button"
                    class="btn-close"
                    @click="emit('hide-modal')"
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body">
                <textarea
                    v-model="row.paymentNote"
                    placeholder="Type here…"
                    rows="10"
                    style="padding: 15px; width: 100%; font-size: 18px; background: #fff; border: none;"
                    @change="saveNote"
                />
            </div>
        </div>
    </div>
</template>